import { Link } from "react-router-dom";

function PopularCard({ _id, image, title }) {
  return (
    <div
      className="card text-dark bg-light mb-3"
      style={{ maxWidth: "15rem", boxSizing: "border-box", cursor: "pointer" }}
    >
      <div className="card-body">
        <Link
          to={`/products/${_id}`}
        >
          <img src={image} style={{ width: "100%" }} alt={title} />
        </Link>
      </div>
      <h5 className="card-header">{title}</h5>
    </div>
  );
}

export default PopularCard;
